module.exports = __webpack_public_path__ + "img/arh_15.91d7490b.png";